import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ otherItem }) => (
    <>
      <DateTime value={otherItem.date} /> &middot; {otherItem.invoiceItem?.name} &middot;{' '}
      <Currency value={otherItem.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Other Items"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .otherItems()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected other item' : `the ${ids.length} selected other items`
      }. Invoiced items will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
